import r from "../managers/braze-instance.js";
import tr from "./feature-flags-provider-factory.js";
import { getAllFeatureFlags } from "./get-all-feature-flags.js";
export function subscribeToFeatureFlagsUpdates(t) {
  if (!r.rr()) return;
  const e = tr.m();
  if (e.Ye()) {
    const r = getAllFeatureFlags();
    r && "function" == typeof t && t(r);
  }
  return e.qt(t);
}
